import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginScreen from './features/login/login';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Dashboard from './features/dashboard/dashboard';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ProfileDetails from './features/profile/profile';
import MainContainer from './features/maincontainer/maincontainer';
import ProtectedRoute from './components/protected-route';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginScreen />} />
      <Route path="/" element={<LoginScreen />} />
      <Route element={<ProtectedRoute />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="/*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
};

export default App;
